import React from "react";
import { MDBContainer, MDBCol, MDBRow } from "mdbreact";
import { Link } from "react-router-dom";

function HomePage(props) {
  return (
    <MDBContainer fluid className="main">
      <MDBRow className="Home">
        <MDBCol md="6">
          <div>
            <MDBContainer fluid>
              <MDBRow>
                <MDBCol md="6" className="week">
                  <Link to="/Monday">
                    <div className="day">MONDAY</div>
                  </Link>

                  <Link to="/Tuesday">
                    <div className="day">TUESDAY</div>
                  </Link>
                  <Link to="/Wednesday">
                    <div className="day">WEDNESDAY</div>
                  </Link>
                  <Link to="/Thursday">
                    <div className="day">THURSDAY</div>
                  </Link>
                  <Link to="/Friday">
                    <div className="day">FRIDAY</div>
                  </Link>
                </MDBCol>
                <MDBCol md="6" className="week2"></MDBCol>
              </MDBRow>
            </MDBContainer>
          </div>
        </MDBCol>
        <MDBCol md="3"></MDBCol>
        <MDBCol md="3"></MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}
export default HomePage;
